import { styled } from '@mui/material/styles';
import { EnrichDialog } from '../enrich-dialog';

export const Wrapper = styled(EnrichDialog)``;
